import { ReduxState } from '../../types';

export const taxoSelector = (state: ReduxState) => state.taxonomy;
export const headerTaxoSelector = (state: ReduxState) => state.taxonomy.header;
export const progressiveHeaderTaxoSelector = (state: ReduxState) =>
  state.taxonomy.progressiveHeader;
export const headerFeaturedTaxoSelector = (state: ReduxState) => state.taxonomy.headerFeatured;
export const footerTaxoSelector = (state: ReduxState) => state.taxonomy.footer;
